import {TreeManager} from '@/services/tree-manager';

export const NodeMixin = {
    props: {
        workflow: {
            type: Object,
            required: false,
        },
        node: {
            type: Object,
            required: true,
        },
        parent: {
            type: Object,
            required: false,
        },
        index: {
            type: Number,
            required: false,
        },
    },
    emits: ['removed'],
    methods: {
        remove() {
            if (confirm('Are you sure?')) {
                TreeManager.removeNode(this.workflow, this.parent, this.node);
                this.$emit('removed');
            }
        },
    },
};
